import { Undo2 } from "lucide-react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "./ui/alert-dialog";

export default function UndoBatchDialog({ batch, onCancel, onConfirm }) {
  return (
    <AlertDialog open={!!batch} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="bg-[#0F1623] border-[#334155] text-[#E5E7EB]" data-testid="undo-batch-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-xl flex items-center gap-2"><Undo2 className="w-5 h-5 text-[#F59E0B]" />Undo production</AlertDialogTitle>
          <AlertDialogDescription className="text-[#9CA3AF]" data-testid="undo-batch-dialog-text">
            Undo production of <b className="text-white">{batch?.name}</b>? Stock and materials will revert to previous levels.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="undo-batch-cancel-btn" className="h-11 bg-transparent border-[#334155] text-[#E5E7EB] hover:bg-[#172033] hover:text-white">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="undo-batch-confirm-btn" onClick={onConfirm} className="h-11 bg-[#F59E0B] text-[#090D16] font-bold hover:bg-[#FBBF24]">Undo Production</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
